<script setup>
import { ref, onMounted, computed } from "vue";
import { useStore } from "vuex";
const iconSignals = new URL("@/assets/icons/worker.svg", import.meta.url).href;
const imgSignals = new URL("@/assets/bg/object7.png", import.meta.url).href;
const iconFiles = new URL("@/assets/icons/files.svg", import.meta.url).href;
const imgFiles = new URL("@/assets/bg/hat_yellow.png", import.meta.url).href;
const iconQuality = new URL("@/assets/icons/home1.svg", import.meta.url).href;
const imgQuality = new URL("@/assets/icons/object7.svg", import.meta.url).href;
import dummyData from "@/utils/dummyData.js";
import ProgressBarCardObject from "./data/ProgressBarCardObject.vue";
import PropertyCard from "./PropertyCard.vue";
import PropertyCardSubLocation from "./PropertyCardSubLocation.vue";
const { quality } = dummyData;

const props = defineProps({
  construction: {
    type: Object,
    required: true,
  },
});

const store = useStore();

const clickedButton = computed(
  () => store.getters["clickedButton/getClickedButton"],
);

const data = ref([]);
const contractorsData = ref([]);
const isLoading = ref(true);

const generateItemImage = (multiply, itemSrc) => {
  if (itemSrc.startsWith('http')) {
    const base = 180;
    return itemSrc + `/S-${base*multiply}`;
  } else {
    return itemSrc;
  }
};

let authToken = computed(() => store.getters["users/tokenUser"]);
let serverUrl = computed(() => store.getters["appData/getServerUrl"]);

const {
  MultiStatisticsServiceClient,
} = require("../proto-out/IMultiStatisticsService_grpc_web_pb");

const {
  ValueRequest_String,
} = require("../proto-out/IMultiStatisticsService_pb.js");

const fetchDataFromGrpc = async () => {
  try {
    const client = new MultiStatisticsServiceClient(serverUrl.value);
    const metadata = { Authorization: `Bearer ${authToken.value}` };
    const request = new ValueRequest_String();
    request.setValue(props.construction.actualinstance);

    const structuresExecutionTree = await new Promise((resolve, reject) => {
      client.getStructuresExecutionTree(request, metadata, (err, response) => {
        if (err) {
          console.error("gRPC Error:", err.message);
          reject(new Error("Failed to fetch data from gRPC"));
        } else {
          console.log("RESPONSE DATA ", response.toObject());
          resolve(response.toObject());
        }
      });
    });

    const contractorsDynamics = await new Promise((resolve, reject) => {
      client.getContractorsDynamics(request, metadata, (err, response) => {
        if (err) {
          console.error("gRPC Error:", err.message);
          reject(new Error("Failed to fetch data from gRPC"));
        } else {
          console.log("RESPONSE DATA ", response.toObject());
          resolve(response.toObject());
        }
      });
    });

    data.value = structuresExecutionTree.valuesList;
    setSubLocationId(structuresExecutionTree.valuesList[0].id)
    contractorsData.value = contractorsDynamics.valuesList;
    isLoading.value = false;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const fetchData = async () => {
  try {
    await fetchDataFromGrpc();
  } catch (err) {
    error.value = "Failed to load data: " + err.message;
    console.error(error.value);
  } finally {
    isLoading.value = false;
  }
};

onMounted(async () => {
  await fetchData();
});

const setSubLocationId = async (index) => {
    try {
      await store.dispatch("appData/setCurrentSubLocationId", index);
    } catch (error) {
        console.error('Error occurred:', error);
    }
};
</script>

<template>
  <v-container>
    <v-row class="mb-5">
      <v-card class="card-title" width="100%">
        <v-row class="pa-0">
          <v-col cols="4" class="pr-0">
            <v-img
              :src="generateItemImage(2,props.construction.imagesource)"
              width="100%"
              height="9.5em"
              rounded="lg"
              cover
            />
          </v-col>
          <v-col cols="8" class="text-left">
            <v-col class="pa-0 ma-0 pt-3">
              <v-card-text class="pa-0 ma-0 responsive-text"
                >ТЕКУЩИЙ ПРОЕКТ</v-card-text
              >
            </v-col>
            <v-col
              class="pa-0 ma-0"
              style="overflow: hidden; padding-bottom: 3vh !important"
            >
              <v-card-title class="marquee-container pa-0 ma-0">
                <span
                  class="marquee responsive-title"
                  :style="{
                    whiteSpace: 'nowrap',
                  }"
                >
                  {{ props.construction.name }}
                </span>
              </v-card-title>
            </v-col>
            <v-col class="pa-0 ma-0 pl-3" align="start">
              <v-row align="center">
                <ProgressBarCardObject
                  title="ВРЕМЯ"
                  :percents="
                    props.construction.constructionplanfact.factpercentage
                  "
                  :size="0.8"
                />
              </v-row>
              <v-row align="center">
                <ProgressBarCardObject
                  title="СДАНО"
                  :percents="
                    props.construction.constructionplanfact.factpercentage
                  "
                  :size="0.8"
                />
              </v-row>
            </v-col>
          </v-col>
        </v-row>
      </v-card>
    </v-row>
    <v-row class="mb-5">
      <PropertyCardSubLocation
        :img="imgSignals"
        :data="data"
        :icon="iconQuality"
        title="Участки в отклонении,"
        subtitle="дни"
      />
    </v-row>
    <v-row>
      <PropertyCard
        :img="imgQuality"
        :data="contractorsData"
        :icon="iconSignals"
        title="Подрядчики в отклонении,"
        subtitle="дни"
        v-if="clickedButton !== 'ПРОИЗВОДСТВО'"
      />
      <PropertyCard
        :img="imgFiles"
        :data="quality"
        :icon="iconFiles"
        title="Показатели в отклонении,"
        subtitle="дни"
        v-else
      />
    </v-row>
  </v-container>
</template>

<style scoped>
.card-title {
  background-color: transparent;
  border: 1px solid #00a3ff;
  padding: 10px;
  box-shadow: inset 0px 0px 15px 5px #00466e;
  border-radius: 8px;
  height: 18vh;
}
.responsive-text {
  font-size: 0.8vw;
  color: lightgray;
}
.responsive-title {
  font-size: 1.5vw;
}
@media (min-width: 1920px) {
  .responsive-text {
    font-size: 0.6vw;
    color: lightgray;
  }
  .responsive-title {
    font-size: 1.1vw;
  }
}
.marquee-container {
  overflow: hidden;
  white-space: nowrap;
}
.marquee {
  display: inline-block; /* Allow horizontal scrolling */
  animation: marquee 20s linear infinite; /* Adjust duration as needed */
}

@keyframes marquee {
  0% {
    transform: translateX(20%); /* Start position */
    opacity: 1;
  }
  85% {
    transform: translateX(-100%); /* End of scroll */
    opacity: 1;
  }
  95% {
    opacity: 0; /* Briefly hide text */
  }
  100% {
    opacity: 0; /* Keep hidden to create a short delay */
  }
}
</style>
